export default __webpack_public_path__ + "static/media/themeActive.27eb734d.svg";